import { useTranslation } from 'react-i18next';
import { featuredItems } from '@/mocks/homeData';

export default function FeaturedSection() {
  const { t } = useTranslation();

  return (
    <section id="featured" className="w-full bg-background-50 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('featured_title')}
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              {t('featured_subtitle')}
            </p>
          </div>

          <div className="overflow-x-auto -mx-4 md:mx-0">
            <table className="w-full min-w-[700px] md:min-w-0 text-sm">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_product')}
                  </th>
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_category')}
                  </th>
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_seller')}
                  </th>
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_qc')}
                  </th>
                  <th className="text-left py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_guide')}
                  </th>
                  <th className="text-right py-3 px-4 font-semibold text-foreground-700 text-xs uppercase tracking-wider">
                    {t('col_action')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {featuredItems.map((item, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-background-200/40 hover:bg-background-100/50 transition-colors"
                  >
                    <td className="py-3.5 px-4 font-medium text-foreground-900">
                      {item.product}
                    </td>
                    <td className="py-3.5 px-4">
                      <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
                        {item.category}
                      </span>
                    </td>
                    <td className="py-3.5 px-4 text-foreground-700">
                      {item.seller}
                    </td>
                    <td className="py-3.5 px-4">
                      <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
                        <i className="ri-check-line text-accent-500" />
                        {item.qc}
                      </span>
                    </td>
                    <td className="py-3.5 px-4 text-foreground-600">
                      {item.guide}
                    </td>
                    <td className="py-3.5 px-4 text-right">
                      <a
                        href="https://kaspreadsheet.com"
                        target="_blank"
                        rel="noopener nofollow"
                        className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                      >
                        {t('action_view')}
                        <i className="ri-external-link-line text-xs" />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}